import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ChatBot from "./components/AIChat/ChatBot";
import StickyCTA from "./components/StickyCTA";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import CaseStudies from "./pages/CaseStudies";
import Booking from "./pages/Booking";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import WebsiteDesign from "./pages/services/WebsiteDesign";
import AIAutomation from "./pages/services/AIAutomation";
import SocialMedia from "./pages/services/SocialMedia";
import LeadGeneration from "./pages/services/LeadGeneration";
import Branding from "./pages/services/Branding";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/website-design" element={<WebsiteDesign />} />
          <Route path="/services/ai-automation" element={<AIAutomation />} />
          <Route path="/services/social-media" element={<SocialMedia />} />
          <Route path="/services/lead-generation" element={<LeadGeneration />} />
          <Route path="/services/branding" element={<Branding />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
        <Footer />
        <StickyCTA />
        <WhatsAppButton />
        <ChatBot />
      </BrowserRouter>
    </div>
  );
}

export default App;
